import {useSelector} from 'react-redux';
import {RootState} from '@/store';

const selector = (store: RootState) => store.application.lang;

export default function useLang() {
    return useSelector(selector);
}
